var Pe = Object.defineProperty;
var Ge = (n, t, r) => t in n ? Pe(n, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : n[t] = r;
var oe = (n, t, r) => (Ge(n, typeof t != "symbol" ? t + "" : t, r), r);
import { utils as u, BaseDocument as d, applyMixins as ze, actions as qe } from "document-model/document";
import { z as e } from "./document-models/account-snapshot.js";
const Qe = {
  id: "powerhouse/budget-statement",
  name: "BudgetStatement",
  extension: "phbs",
  description: "The BudgetStatement module manages the state and actions related to budget statements, which are documents that track the financial transactions of an organization over a month.",
  author: {
    name: "Powerhouse",
    website: "https://powerhouse.inc/"
  },
  specifications: [
    {
      version: 1,
      changeLog: [],
      modules: [
        {
          name: "account",
          operations: [
            {
              name: "AddAccount",
              id: "",
              description: "",
              schema: `input AddAccountInput {
    address: String!
    name: String
    lineItems: [LineItemInput!]
}`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "UpdateAccount",
              id: "",
              description: "",
              schema: `input UpdateAccountInput {
    address: String!
    name: String
    lineItems: [LineItem!]
}`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "DeleteAccount",
              id: "",
              description: "",
              schema: `input DeleteAccountInput {
    account: String!
}`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "SortAccounts",
              id: "",
              description: "",
              schema: `input SortAccountsInput {
    accounts: [String!]!
}`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            }
          ],
          id: "",
          description: ""
        },
        {
          name: "line-item",
          operations: [
            {
              name: "AddLineItem",
              id: "",
              description: "",
              schema: `input AddLineItemInput {
 accountId: ID!
 group: LineItemGroup
 headcountExpense: Boolean
 category: LineItemCategory
 budgetCap: Float
 actual: Float
 payment: Float
 forecast: [LineItemForecast!]
 comment: String }`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "UpdateLineItem",
              id: "",
              description: "",
              schema: `input LineItemUpdateInput {
 group: String
 category: String
 headcountExpense: Boolean
 budgetCap: Float
 actual: Float
 payment: Float
 forecast: [LineItemForecast!]
 comment: String }

input UpdateLineItemInput {
 accountId: ID!
 group: String
 category: String
 headcountExpense: Boolean
 budgetCap: Float
 actual: Float
 payment: Float
 forecast: [LineItemForecast!]
 comment: String }`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "DeleteLineItem",
              id: "",
              description: "",
              schema: `input DeleteLineItemInput {
 accountId: ID!
 group: String
 category: String }

`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "SortLineItems",
              id: "",
              description: "",
              schema: `input LineItemsSortInput {
 group: String
 category: String }

input SortLineItemsInput {
 accountId: ID!
 lineItems: [LineItemsSortInput!]! }`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            }
          ],
          id: "",
          description: ""
        },
        {
          name: "base",
          operations: [
            {
              name: "SetOwner",
              id: "",
              description: "",
              schema: `input SetOwnerInput {
 ref: String
 id: String
 title: String }`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "SetMonth",
              id: "",
              description: "",
              schema: `input SetMonthInput {
 month: String! }`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "SetFtes",
              id: "",
              description: "",
              schema: `input FtesForecastInput {
 month: String!
 value: Float! }

input SetFtesInput {
 value: Float!
 forecast: [FtesForecastInput!]! }`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "SetQuoteCurrency",
              id: "",
              description: "",
              schema: `input SetQuoteCurrencyInput {
 quoteCurrency: String! }`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            }
          ],
          id: "",
          description: ""
        },
        {
          name: "audit",
          operations: [
            {
              name: "AddAuditReport",
              id: "",
              description: "",
              schema: `input AddAuditReportInput {
timestamp: DateTime
report: Attachment!
status: AuditReportStatus!
}`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "DeleteAuditReport",
              id: "",
              description: "",
              schema: `input DeleteAuditReportInput {
report: String!
}`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            }
          ],
          id: "",
          description: ""
        },
        {
          name: "comment",
          operations: [
            {
              name: "AddComment",
              id: "",
              description: "",
              schema: `input CommentAuthorInput {
 ref: String
 id: String
 username: String
 roleLabel: String }

input AddCommentInput {
 key: String
 author: CommentAuthorInput
 comment: String!
 timestamp: DateTime
 status: BudgetStatus }`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "UpdateComment",
              id: "",
              description: "",
              schema: `input UpdateCommentInput {
 key: String!
 author: CommentAuthorInput
 comment: String
 timestamp: DateTime
 status: BudgetStatus }`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "DeleteComment",
              id: "",
              description: "",
              schema: `input DeleteCommentInput {
 comment: String! }`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            }
          ],
          id: "",
          description: ""
        },
        {
          name: "vesting",
          operations: [
            {
              name: "AddVesting",
              id: "",
              description: "",
              schema: `input AddVestingInput {
 key: String
 date: String
 amount: String
 amountOld: String
 comment: String
 currency: String
 vested: Boolean }`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "UpdateVesting",
              id: "",
              description: "",
              schema: `input UpdateVestingInput {
 key: String!
 date: String
 amount: String
 amountOld: String
 comment: String
 currency: String
 vested: Boolean }`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "DeleteVesting",
              id: "",
              description: "",
              schema: `input DeleteVestingInput {
 vesting: String! }`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            }
          ],
          id: "",
          description: ""
        }
      ],
      state: {
        global: {
          schema: `scalar DateTime
scalar Attachment

input LineItemInput {
    group: LineItemGroup
    headcountExpense: Boolean
    category: LineItemCategory
    budgetCap: Float
    actual: Float
    payment: Float
    forecast: [LineItemForecast!]
    comment: String }                    

type LineItemGroup {
    ref: String!
    id: String!
    title: String!
    color: String!
}

type LineItemCategory {
    ref: String!
    id: String!
    title: String!
}

type LineItemForecast {
    month: String!
    value: Float!
    budgetCap: Float!
}

type LineItem {
    group: LineItemGroup
    headcountExpense: Boolean!
    category: LineItemCategory
    budgetCap: Float
    actual: Float
    payment: Float
    forecast: [LineItemForecast!]!
    comment: String
}

type Account {
    address: String! # TODO Address
    name: String!
    lineItems: [LineItem!]!
}

type Owner {
    ref: String
    id: String
    title: String
}

type Vesting {
    key: String!
    date: String!
    amount: String!
    amountOld: String!
    comment: String!
    currency: String!
    vested: Boolean!
}

type FtesForecast {
    month: String!
    value: Float!
}

type Ftes {
    value: Float!
    forecast: [FtesForecast!]!
}

enum AuditReportStatus {
    Approved
    ApprovedWithComments
    NeedsAction
    Escalated
}

type AuditReport {
    timestamp: DateTime!
    report: Attachment! # TODO enforce attachment
    status: AuditReportStatus!
}

type CommentAuthor {
    ref: String
    id: String
    username: String
    roleLabel: String
}

enum BudgetStatus {
    Draft
    Review
    Final
    Escalated
}

type Comment {
    key: String!
    author: CommentAuthor!
    comment: String!
    timestamp: DateTime!
    status: BudgetStatus!
}

type BudgetStatementState {
    owner: Owner
    month: String
    quoteCurrency: String
    accounts: [Account!]!
    vesting: [Vesting!]!
    ftes: Ftes
    auditReports: [AuditReport!]!
    comments: [Comment!]!
}`,
          initialValue: '"{\\n    \\"owner\\": {\\n        \\"ref\\": null,\\n        \\"id\\": null,\\n        \\"title\\": null\\n    },\\n    \\"month\\": null,\\n    \\"quoteCurrency\\": null,\\n    \\"vesting\\": [],\\n    \\"ftes\\": null,\\n    \\"accounts\\": [],\\n    \\"auditReports\\": [],\\n    \\"comments\\": []\\n}"',
          examples: []
        },
        local: {
          schema: "type BudgetStatementLocalState",
          initialValue: '"{}"',
          examples: []
        }
      }
    }
  ]
}, ue = (n) => n != null, He = e.any().refine((n) => ue(n)), F = e.enum(["Approved", "ApprovedWithComments", "Escalated", "NeedsAction"]), E = e.enum(["Draft", "Escalated", "Final", "Review"]);
function ce() {
  return e.object({
    __typename: e.literal("Account").optional(),
    address: e.string(),
    lineItems: e.array(P()),
    name: e.string()
  });
}
function v() {
  return e.object({
    address: e.string(),
    lineItems: e.array(e.lazy(() => Se())).nullish(),
    name: e.string().nullish()
  });
}
function w() {
  return e.object({
    report: e.string(),
    status: F,
    timestamp: e.string().datetime().nullish()
  });
}
function R() {
  return e.object({
    author: e.lazy(() => N().nullish()),
    comment: e.string(),
    key: e.string().nullish(),
    status: E.nullish(),
    timestamp: e.string().datetime().nullish()
  });
}
function k() {
  return e.object({
    accountId: e.string(),
    actual: e.number().nullish(),
    budgetCap: e.number().nullish(),
    category: O().nullish(),
    comment: e.string().nullish(),
    forecast: e.array(p()).nullish(),
    group: C().nullish(),
    headcountExpense: e.boolean().nullish(),
    payment: e.number().nullish()
  });
}
function j() {
  return e.object({
    amount: e.string().nullish(),
    amountOld: e.string().nullish(),
    comment: e.string().nullish(),
    currency: e.string().nullish(),
    date: e.string().nullish(),
    key: e.string().nullish(),
    vested: e.boolean().nullish()
  });
}
function le() {
  return e.object({
    __typename: e.literal("AuditReport").optional(),
    report: e.string(),
    status: F,
    timestamp: e.string().datetime()
  });
}
function We() {
  return e.object({
    __typename: e.literal("BudgetStatementLocalState").optional()
  });
}
function Ke() {
  return e.object({
    __typename: e.literal("BudgetStatementState").optional(),
    accounts: e.array(ce()),
    auditReports: e.array(le()),
    comments: e.array(me()),
    ftes: pe().nullable(),
    month: e.string().nullable(),
    owner: be().nullable(),
    quoteCurrency: e.string().nullable(),
    vesting: e.array(ye())
  });
}
function me() {
  return e.object({
    __typename: e.literal("Comment").optional(),
    author: de(),
    comment: e.string(),
    key: e.string(),
    status: E,
    timestamp: e.string().datetime()
  });
}
function de() {
  return e.object({
    __typename: e.literal("CommentAuthor").optional(),
    id: e.string().nullable(),
    ref: e.string().nullable(),
    roleLabel: e.string().nullable(),
    username: e.string().nullable()
  });
}
function N() {
  return e.object({
    id: e.string().nullish(),
    ref: e.string().nullish(),
    roleLabel: e.string().nullish(),
    username: e.string().nullish()
  });
}
function U() {
  return e.object({
    account: e.string()
  });
}
function V() {
  return e.object({
    report: e.string()
  });
}
function M() {
  return e.object({
    comment: e.string()
  });
}
function B() {
  return e.object({
    accountId: e.string(),
    category: e.string().nullish(),
    group: e.string().nullish()
  });
}
function $() {
  return e.object({
    vesting: e.string()
  });
}
function pe() {
  return e.object({
    __typename: e.literal("Ftes").optional(),
    forecast: e.array(ge()),
    value: e.number()
  });
}
function ge() {
  return e.object({
    __typename: e.literal("FtesForecast").optional(),
    month: e.string(),
    value: e.number()
  });
}
function he() {
  return e.object({
    month: e.string(),
    value: e.number()
  });
}
function P() {
  return e.object({
    __typename: e.literal("LineItem").optional(),
    actual: e.number().nullable(),
    budgetCap: e.number().nullable(),
    category: O().nullable(),
    comment: e.string().nullable(),
    forecast: e.array(p()),
    group: C().nullable(),
    headcountExpense: e.boolean(),
    payment: e.number().nullable()
  });
}
function O() {
  return e.object({
    __typename: e.literal("LineItemCategory").optional(),
    id: e.string(),
    ref: e.string(),
    title: e.string()
  });
}
function p() {
  return e.object({
    __typename: e.literal("LineItemForecast").optional(),
    budgetCap: e.number(),
    month: e.string(),
    value: e.number()
  });
}
function C() {
  return e.object({
    __typename: e.literal("LineItemGroup").optional(),
    color: e.string(),
    id: e.string(),
    ref: e.string(),
    title: e.string()
  });
}
function Se() {
  return e.object({
    actual: e.number().nullish(),
    budgetCap: e.number().nullish(),
    category: O().nullish(),
    comment: e.string().nullish(),
    forecast: e.array(p()).nullish(),
    group: C().nullish(),
    headcountExpense: e.boolean().nullish(),
    payment: e.number().nullish()
  });
}
function Ye() {
  return e.object({
    actual: e.number().nullish(),
    budgetCap: e.number().nullish(),
    category: e.string().nullish(),
    comment: e.string().nullish(),
    forecast: e.array(p()).nullish(),
    group: e.string().nullish(),
    headcountExpense: e.boolean().nullish(),
    payment: e.number().nullish()
  });
}
function Ie() {
  return e.object({
    category: e.string().nullish(),
    group: e.string().nullish()
  });
}
function be() {
  return e.object({
    __typename: e.literal("Owner").optional(),
    id: e.string().nullable(),
    ref: e.string().nullable(),
    title: e.string().nullable()
  });
}
function G() {
  return e.object({
    forecast: e.array(e.lazy(() => he())),
    value: e.number()
  });
}
function z() {
  return e.object({
    month: e.string()
  });
}
function q() {
  return e.object({
    id: e.string().nullish(),
    ref: e.string().nullish(),
    title: e.string().nullish()
  });
}
function Q() {
  return e.object({
    quoteCurrency: e.string()
  });
}
function H() {
  return e.object({
    accounts: e.array(e.string())
  });
}
function W() {
  return e.object({
    accountId: e.string(),
    lineItems: e.array(e.lazy(() => Ie()))
  });
}
function K() {
  return e.object({
    address: e.string(),
    lineItems: e.array(P()).nullish(),
    name: e.string().nullish()
  });
}
function Y() {
  return e.object({
    author: e.lazy(() => N().nullish()),
    comment: e.string().nullish(),
    key: e.string(),
    status: E.nullish(),
    timestamp: e.string().datetime().nullish()
  });
}
function J() {
  return e.object({
    accountId: e.string(),
    actual: e.number().nullish(),
    budgetCap: e.number().nullish(),
    category: e.string().nullish(),
    comment: e.string().nullish(),
    forecast: e.array(p()).nullish(),
    group: e.string().nullish(),
    headcountExpense: e.boolean().nullish(),
    payment: e.number().nullish()
  });
}
function X() {
  return e.object({
    amount: e.string().nullish(),
    amountOld: e.string().nullish(),
    comment: e.string().nullish(),
    currency: e.string().nullish(),
    date: e.string().nullish(),
    key: e.string(),
    vested: e.boolean().nullish()
  });
}
function ye() {
  return e.object({
    __typename: e.literal("Vesting").optional(),
    amount: e.string(),
    amountOld: e.string(),
    comment: e.string(),
    currency: e.string(),
    date: e.string(),
    key: e.string(),
    vested: e.boolean()
  });
}
const ht = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccountSchema: ce,
  AddAccountInputSchema: v,
  AddAuditReportInputSchema: w,
  AddCommentInputSchema: R,
  AddLineItemInputSchema: k,
  AddVestingInputSchema: j,
  AuditReportSchema: le,
  AuditReportStatusSchema: F,
  BudgetStatementLocalStateSchema: We,
  BudgetStatementStateSchema: Ke,
  BudgetStatusSchema: E,
  CommentAuthorInputSchema: N,
  CommentAuthorSchema: de,
  CommentSchema: me,
  DeleteAccountInputSchema: U,
  DeleteAuditReportInputSchema: V,
  DeleteCommentInputSchema: M,
  DeleteLineItemInputSchema: B,
  DeleteVestingInputSchema: $,
  FtesForecastInputSchema: he,
  FtesForecastSchema: ge,
  FtesSchema: pe,
  LineItemCategorySchema: O,
  LineItemForecastSchema: p,
  LineItemGroupSchema: C,
  LineItemInputSchema: Se,
  LineItemSchema: P,
  LineItemUpdateInputSchema: Ye,
  LineItemsSortInputSchema: Ie,
  OwnerSchema: be,
  SetFtesInputSchema: G,
  SetMonthInputSchema: z,
  SetOwnerInputSchema: q,
  SetQuoteCurrencyInputSchema: Q,
  SortAccountsInputSchema: H,
  SortLineItemsInputSchema: W,
  UpdateAccountInputSchema: K,
  UpdateCommentInputSchema: Y,
  UpdateLineItemInputSchema: J,
  UpdateVestingInputSchema: X,
  VestingSchema: ye,
  definedNonNullAnySchema: He,
  isDefinedNonNullAny: ue
}, Symbol.toStringTag, { value: "Module" })), fe = (n) => {
  var t;
  return {
    ...n,
    name: n.name ?? "",
    lineItems: ((t = n.lineItems) == null ? void 0 : t.map(Z)) ?? new Array()
  };
}, Z = (n) => {
  var t;
  return {
    budgetCap: null,
    payment: null,
    actual: null,
    comment: null,
    ...n,
    forecast: ((t = n.forecast) == null ? void 0 : t.sort(
      (r, o) => r.month.localeCompare(o.month)
    )) ?? new Array(),
    headcountExpense: n.headcountExpense ?? !1,
    group: n.group ?? null,
    category: n.category ?? null
  };
}, Je = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createAccount: fe,
  createLineItem: Z
}, Symbol.toStringTag, { value: "Module" })), h = {
  addAccountOperation(n, t) {
    const { input: r } = t;
    if (n.accounts.find((o) => o.address === r.address))
      throw new Error(
        `Account with address ${r.address} already exists!`
      );
    n.accounts.push(fe(r));
  },
  updateAccountOperation(n, t) {
    const { input: r } = t, o = n.accounts.findIndex(
      (i) => i.address === r.address
    );
    if (o === -1)
      throw new Error(`Account with adddress ${r.address} not found`);
    const a = n.accounts[o];
    n.accounts[o] = {
      ...a,
      lineItems: r.lineItems ?? a.lineItems,
      name: r.name ?? a.name
    };
  },
  deleteAccountOperation(n, t) {
    const { input: r } = t;
    n.accounts = n.accounts.filter(
      (o) => o.address !== r.account
    );
  },
  sortAccountsOperation(n, t) {
    n.accounts.sort((r, o) => {
      const a = t.input.accounts.indexOf(r.address), i = t.input.accounts.indexOf(o.address);
      return (a > -1 ? a : 1 / 0) - (i > -1 ? i : 1 / 0);
    });
  }
};
function S(n, t) {
  return n.category === t.category && n.group === t.group;
}
const I = {
  addLineItemOperation(n, t) {
    var i, c;
    const { accountId: r, ...o } = t.input, a = n.accounts.find((s) => s.address === r);
    if (!a)
      throw new Error(`Account with address ${r} not found`);
    if (a.lineItems.find(
      (s) => {
        var l, m, ne, re;
        return ((l = o.category) == null ? void 0 : l.id) === ((m = s.category) == null ? void 0 : m.id) && ((ne = o.group) == null ? void 0 : ne.id) === ((re = s.group) == null ? void 0 : re.id);
      }
    ))
      throw new Error(
        `Line item with category '${((i = o.category) == null ? void 0 : i.id) ?? "null"}' and group '${((c = o.group) == null ? void 0 : c.id) ?? "null"}' already exists`
      );
    a.lineItems.push(Z(o));
  },
  updateLineItemOperation(n, t) {
    const { accountId: r, ...o } = t.input, a = n.accounts.find((s) => s.address === r);
    if (!a)
      throw new Error(`Account with address ${r} not found`);
    const i = a.lineItems.findIndex(
      (s) => S(o, s)
    );
    if (i === -1)
      throw new Error("Line item not found");
    const c = a.lineItems[i];
    a.lineItems[i] = {
      ...c,
      ...o,
      category: c.category,
      headcountExpense: o.headcountExpense ?? !1,
      group: c.group,
      forecast: (o.forecast ?? c.forecast).sort((s, l) => s.month.localeCompare(l.month))
    };
  },
  deleteLineItemOperation(n, t) {
    const { accountId: r, ...o } = t.input, a = n.accounts.find((i) => i.address === r);
    if (!a)
      throw new Error(`Account with address ${r} not found`);
    a.lineItems = a.lineItems.filter(
      (i) => !S(o, i)
    );
  },
  sortLineItemsOperation(n, t) {
    const { accountId: r, lineItems: o } = t.input, a = n.accounts.find((i) => i.address === r);
    if (!a)
      throw new Error(`Account with address ${r} not found`);
    a.lineItems.sort((i, c) => {
      const s = o.findIndex((m) => S(m, i)), l = o.findIndex((m) => S(m, c));
      return (s > -1 ? s : 1 / 0) - (l > -1 ? l : 1 / 0);
    });
  }
}, b = {
  setOwnerOperation(n, t) {
    n.owner = {
      id: t.input.id ?? null,
      ref: t.input.ref ?? null,
      title: t.input.title ?? null
    };
  },
  setMonthOperation(n, t) {
    n.month = t.input.month;
  },
  setFtesOperation(n, t) {
    n.ftes = t.input, n.ftes.forecast.sort((r, o) => r.month.localeCompare(o.month));
  },
  setQuoteCurrencyOperation(n, t) {
    n.quoteCurrency = t.input.quoteCurrency;
  }
};
function Xe(n, t) {
  if (n.auditReports.find((r) => r.report === t))
    throw new Error(`Audit with report ${t} already exists`);
}
const ae = {
  addAuditReportOperation(n, t) {
    if (Xe(n, t.input.report), !t.attachments.find(
      (r) => r.hash === t.input.report
    ))
      throw new Error(
        "Report was not included in the action attachments"
      );
    n.auditReports.push({
      ...t.input,
      timestamp: t.input.timestamp ?? (/* @__PURE__ */ new Date()).toISOString()
    });
  },
  deleteAuditReportOperation(n, t) {
    const r = n.auditReports.findIndex(
      (o) => o.report === t.input.report
    );
    r > -1 && n.auditReports.splice(r, 1);
  }
}, ie = (n, t) => n.timestamp < t.timestamp ? -1 : 1, D = {
  addCommentOperation(n, t) {
    const { input: r } = t, o = r.key ?? u.hashKey();
    if (n.comments.findIndex((i) => i.key === r.key) > -1)
      throw new Error(`Comment with key ${o} already exists`);
    n.comments.push({
      key: o,
      author: {
        ref: null,
        id: null,
        username: null,
        roleLabel: null,
        ...r.author
      },
      comment: r.comment,
      timestamp: r.timestamp || (/* @__PURE__ */ new Date()).toISOString(),
      status: r.status ?? "Draft"
    }), n.comments.sort(ie);
  },
  updateCommentOperation(n, t) {
    var i, c, s, l;
    const { input: r } = t, o = n.comments.findIndex((m) => m.key === r.key);
    if (o === -1)
      return;
    const a = n.comments[o];
    n.comments[o] = {
      ...a,
      ...r,
      author: {
        id: ((i = r.author) == null ? void 0 : i.id) ?? a.author.id,
        ref: ((c = r.author) == null ? void 0 : c.ref) ?? a.author.ref,
        roleLabel: ((s = r.author) == null ? void 0 : s.roleLabel) ?? a.author.roleLabel,
        username: ((l = r.author) == null ? void 0 : l.username) ?? a.author.username
      },
      comment: r.comment ?? a.comment,
      timestamp: r.timestamp ?? (/* @__PURE__ */ new Date()).toISOString(),
      status: r.status ?? a.status
    }, n.comments.sort(ie);
  },
  deleteCommentOperation(n, t) {
    const { input: r } = t;
    n.comments = n.comments.filter(
      (o) => r.comment !== o.key
    );
  }
}, se = (n, t) => n.date < t.date ? -1 : 1, x = {
  addVestingOperation(n, t) {
    const { input: r } = t, o = r.key ?? u.hashKey();
    if (n.vesting.findIndex((i) => i.key === r.key) > -1)
      throw new Error(`Vesting with key ${o} already exists`);
    n.vesting.push({
      ...r,
      key: o,
      date: r.date ?? "",
      amount: r.amount ?? "",
      amountOld: r.amountOld ?? r.amount ?? "",
      comment: r.comment ?? "",
      currency: r.currency ?? "",
      vested: r.vested ?? !1
    }), n.vesting.sort(se);
  },
  updateVestingOperation(n, t) {
    const { input: r } = t, o = n.vesting.findIndex((i) => i.key === r.key);
    if (o === -1)
      return;
    const a = n.vesting[o];
    n.vesting[o] = {
      ...a,
      ...r,
      amount: r.amount ?? a.amount,
      amountOld: r.amountOld ?? a.amountOld,
      comment: r.comment ?? a.comment,
      currency: r.currency ?? a.currency,
      date: r.date ?? a.date,
      vested: r.vested ?? a.vested
    }, n.vesting.sort(se);
  },
  deleteVestingOperation(n, t) {
    n.vesting = n.vesting.filter(
      (r) => !t.input.vesting.includes(r.key)
    );
  }
}, Ze = (n, t, r) => {
  if (u.isBaseAction(t))
    return n;
  switch (t.type) {
    case "ADD_ACCOUNT":
      v().parse(t.input), h.addAccountOperation(n[t.scope], t, r);
      break;
    case "UPDATE_ACCOUNT":
      K().parse(t.input), h.updateAccountOperation(n[t.scope], t, r);
      break;
    case "DELETE_ACCOUNT":
      U().parse(t.input), h.deleteAccountOperation(n[t.scope], t, r);
      break;
    case "SORT_ACCOUNTS":
      H().parse(t.input), h.sortAccountsOperation(n[t.scope], t, r);
      break;
    case "ADD_LINE_ITEM":
      k().parse(t.input), I.addLineItemOperation(n[t.scope], t, r);
      break;
    case "UPDATE_LINE_ITEM":
      J().parse(t.input), I.updateLineItemOperation(n[t.scope], t, r);
      break;
    case "DELETE_LINE_ITEM":
      B().parse(t.input), I.deleteLineItemOperation(n[t.scope], t, r);
      break;
    case "SORT_LINE_ITEMS":
      W().parse(t.input), I.sortLineItemsOperation(n[t.scope], t, r);
      break;
    case "SET_OWNER":
      q().parse(t.input), b.setOwnerOperation(n[t.scope], t, r);
      break;
    case "SET_MONTH":
      z().parse(t.input), b.setMonthOperation(n[t.scope], t, r);
      break;
    case "SET_FTES":
      G().parse(t.input), b.setFtesOperation(n[t.scope], t, r);
      break;
    case "SET_QUOTE_CURRENCY":
      Q().parse(t.input), b.setQuoteCurrencyOperation(n[t.scope], t, r);
      break;
    case "ADD_AUDIT_REPORT":
      w().parse(t.input), ae.addAuditReportOperation(n[t.scope], t, r);
      break;
    case "DELETE_AUDIT_REPORT":
      V().parse(t.input), ae.deleteAuditReportOperation(n[t.scope], t, r);
      break;
    case "ADD_COMMENT":
      R().parse(t.input), D.addCommentOperation(n[t.scope], t, r);
      break;
    case "UPDATE_COMMENT":
      Y().parse(t.input), D.updateCommentOperation(n[t.scope], t, r);
      break;
    case "DELETE_COMMENT":
      M().parse(t.input), D.deleteCommentOperation(n[t.scope], t, r);
      break;
    case "ADD_VESTING":
      j().parse(t.input), x.addVestingOperation(n[t.scope], t, r);
      break;
    case "UPDATE_VESTING":
      X().parse(t.input), x.updateVestingOperation(n[t.scope], t, r);
      break;
    case "DELETE_VESTING":
      $().parse(t.input), x.deleteVestingOperation(n[t.scope], t, r);
      break;
    default:
      return n;
  }
}, y = u.createReducer(Ze), et = {
  owner: {
    ref: null,
    id: null,
    title: null
  },
  month: null,
  quoteCurrency: null,
  vesting: [],
  ftes: null,
  accounts: [],
  auditReports: [],
  comments: []
}, tt = {}, g = {
  fileExtension: "phbs",
  createState(n) {
    return { global: { ...et, ...n == null ? void 0 : n.global }, local: { ...tt, ...n == null ? void 0 : n.local } };
  },
  createExtendedState(n) {
    return u.createExtendedState(
      { ...n, documentType: "powerhouse/budget-statement" },
      g.createState
    );
  },
  createDocument(n) {
    return u.createDocument(
      g.createExtendedState(n),
      g.createState
    );
  },
  saveToFile(n, t, r) {
    return u.saveToFile(n, t, "phbs", r);
  },
  saveToFileHandle(n, t) {
    return u.saveToFileHandle(n, t);
  },
  loadFromFile(n) {
    return u.loadFromFile(n, y);
  },
  loadFromInput(n) {
    return u.loadFromInput(n, y);
  }
}, { createAction: _ } = u, Ae = (n) => _(
  "ADD_ACCOUNT",
  { ...n },
  void 0,
  v,
  "global"
), Ee = (n) => _(
  "UPDATE_ACCOUNT",
  { ...n },
  void 0,
  K,
  "global"
), Oe = (n) => _(
  "DELETE_ACCOUNT",
  { ...n },
  void 0,
  U,
  "global"
), Ce = (n) => _(
  "SORT_ACCOUNTS",
  { ...n },
  void 0,
  H,
  "global"
);
class nt extends d {
  addAccount(t) {
    return this.dispatch(Ae(t));
  }
  updateAccount(t) {
    return this.dispatch(Ee(t));
  }
  deleteAccount(t) {
    return this.dispatch(Oe(t));
  }
  sortAccounts(t) {
    return this.dispatch(Ce(t));
  }
}
const { createAction: L } = u, _e = (n) => L(
  "ADD_LINE_ITEM",
  { ...n },
  void 0,
  k,
  "global"
), Le = (n) => L(
  "UPDATE_LINE_ITEM",
  { ...n },
  void 0,
  J,
  "global"
), Te = (n) => L(
  "DELETE_LINE_ITEM",
  { ...n },
  void 0,
  B,
  "global"
), De = (n) => L(
  "SORT_LINE_ITEMS",
  { ...n },
  void 0,
  W,
  "global"
);
class rt extends d {
  addLineItem(t) {
    return this.dispatch(_e(t));
  }
  updateLineItem(t) {
    return this.dispatch(Le(t));
  }
  deleteLineItem(t) {
    return this.dispatch(Te(t));
  }
  sortLineItems(t) {
    return this.dispatch(De(t));
  }
}
const { createAction: T } = u, xe = (n) => T(
  "SET_OWNER",
  { ...n },
  void 0,
  q,
  "global"
), Fe = (n) => T(
  "SET_MONTH",
  { ...n },
  void 0,
  z,
  "global"
), ve = (n) => T(
  "SET_FTES",
  { ...n },
  void 0,
  G,
  "global"
), we = (n) => T(
  "SET_QUOTE_CURRENCY",
  { ...n },
  void 0,
  Q,
  "global"
);
class ot extends d {
  setOwner(t) {
    return this.dispatch(xe(t));
  }
  setMonth(t) {
    return this.dispatch(Fe(t));
  }
  setFtes(t) {
    return this.dispatch(ve(t));
  }
  setQuoteCurrency(t) {
    return this.dispatch(we(t));
  }
}
const { createAction: Re } = u, ke = (n, t) => Re(
  "ADD_AUDIT_REPORT",
  { ...n },
  t,
  w,
  "global"
), je = (n) => Re(
  "DELETE_AUDIT_REPORT",
  { ...n },
  void 0,
  V,
  "global"
);
class at extends d {
  addAuditReport(t, r) {
    return this.dispatch(ke(t, r));
  }
  deleteAuditReport(t) {
    return this.dispatch(je(t));
  }
}
const { createAction: ee } = u, Ne = (n) => ee(
  "ADD_COMMENT",
  { ...n },
  void 0,
  R,
  "global"
), Ue = (n) => ee(
  "UPDATE_COMMENT",
  { ...n },
  void 0,
  Y,
  "global"
), Ve = (n) => ee(
  "DELETE_COMMENT",
  { ...n },
  void 0,
  M,
  "global"
);
class it extends d {
  addComment(t) {
    return this.dispatch(Ne(t));
  }
  updateComment(t) {
    return this.dispatch(Ue(t));
  }
  deleteComment(t) {
    return this.dispatch(Ve(t));
  }
}
const { createAction: te } = u, Me = (n) => te(
  "ADD_VESTING",
  { ...n },
  void 0,
  j,
  "global"
), Be = (n) => te(
  "UPDATE_VESTING",
  { ...n },
  void 0,
  X,
  "global"
), $e = (n) => te(
  "DELETE_VESTING",
  { ...n },
  void 0,
  $,
  "global"
);
class st extends d {
  addVesting(t) {
    return this.dispatch(Me(t));
  }
  updateVesting(t) {
    return this.dispatch(Be(t));
  }
  deleteVesting(t) {
    return this.dispatch($e(t));
  }
}
const A = class A extends d {
  constructor(t, r) {
    super(y, g.createDocument(t), r);
  }
  saveToFile(t, r) {
    return super.saveToFile(t, A.fileExtension, r);
  }
  loadFromFile(t) {
    return super.loadFromFile(t);
  }
  static async fromFile(t) {
    const r = new this();
    return await r.loadFromFile(t), r;
  }
};
oe(A, "fileExtension", "phbs");
let f = A;
ze(f, [
  nt,
  rt,
  ot,
  at,
  it,
  st
]);
const ut = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addAccount: Ae,
  addAuditReport: ke,
  addComment: Ne,
  addLineItem: _e,
  addVesting: Me,
  deleteAccount: Oe,
  deleteAuditReport: je,
  deleteComment: Ve,
  deleteLineItem: Te,
  deleteVesting: $e,
  setFtes: ve,
  setMonth: Fe,
  setOwner: xe,
  setQuoteCurrency: we,
  sortAccounts: Ce,
  sortLineItems: De,
  updateAccount: Ee,
  updateComment: Ue,
  updateLineItem: Le,
  updateVesting: Be
}, Symbol.toStringTag, { value: "Module" })), ct = f, lt = { ...g, ...Je }, mt = { ...qe, ...ut }, St = {
  Document: ct,
  reducer: y,
  actions: mt,
  utils: lt,
  documentModel: Qe
};
export {
  f as BudgetStatement,
  ct as Document,
  mt as actions,
  fe as createAccount,
  Z as createLineItem,
  Qe as documentModel,
  St as module,
  y as reducer,
  lt as utils,
  ht as z
};
